/**
 * This job vacancies search module works on top of "PCG.CMS.Web.Core.Features.JobVacanciesSearch" module.
 * It is used on the "Gloucestershire Assistants" microsite. See "JobVacanciesListingPage" for details.
 */

import { NgModule } from "@angular/core";
import { CommonComponentsModule } from "apps-module/app/common-components/common-components.module";
import { NouisliderModule } from "ng2-nouislider";

import { ResultItemComponent } from "./components/search-results/result-item/result-item.component";
import { SearchResultsComponent } from "./components/search-results/search-results.component";
import { VacanciesSearchComponent } from "./vacancies-search.component";

@NgModule({
    declarations: [
        VacanciesSearchComponent,
        ResultItemComponent,
        SearchResultsComponent
    ],
    exports: [VacanciesSearchComponent],
    imports: [
        CommonComponentsModule,
        NouisliderModule
    ]
})
export class VacanciesSearchModule {
}
